import { DocumentQuickPulse } from "./DocumentQuickPulse";

export interface MessageDocumentQuickPulse extends DocumentQuickPulse {
    Message: string;
    SeverityLevel: string;
}
